import React, { memo } from 'react';

import { useProductConfig } from '../../../../../../../store/hooks/productPopupInfo';
import productTypes from '../../../enums/productTypes';

import DepositsInsuredIcon from './DepositsInsuredIcon';
import style from './style.module.scss';

interface IInfoProps {
  organizationName: string;
}

const TEXT =
  'участник Системы обязательного страхования вкладов. Вклады в банке застрахованы государством в пределах 1,4 млн рублей.';

const InfoDepositBlock: React.FC<IInfoProps> = memo(({ organizationName }) => {
  const productConfig = useProductConfig();
  const isDeposits = productConfig.name === productTypes.Deposits;

  if (!isDeposits) {
    return null;
  }

  return (
    <div className={style.wrapper}>
      <div>
        <DepositsInsuredIcon />
      </div>
      <div className={style.text}>{`${organizationName} — ${TEXT}`}</div>
    </div>
  );
});

export default InfoDepositBlock;
